import React from 'react';
import { useParams } from 'react-router-dom';
import Board from '../components/board/Board';

const BoardView = () => {
  const { boardIdOrSlug } = useParams();
  
  return (
    <div>
      <Board boardId={boardIdOrSlug} />
    </div>
  );
};

export default BoardView;